import styled from 'styled-components';

import { common } from 'themes/default';

const { alert } = common.notifications;

export const StyledDisruptionAnchor = styled.span`
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin-right: 4px;
  white-space: nowrap;
  cursor: pointer;

  svg {
    width: 12px;
    height: 12px;
    margin-bottom: 2px;
  }

  path {
    fill: ${alert.borderColour};
  }

  &:focus {
    outline: 1px solid ${alert.borderColour};
    outline-offset: 1px;
  }
`;

export const StyledDelay = styled.span`
  margin-left: 4px;
  font-weight: bold;
  color: ${alert.borderColour};
`;

export const StyledTooltipContent = styled.div`
  max-width: min(360px, calc(100vw - 32px));
  max-height: min(50vh, 280px);
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-right: 8px;
  text-align: left;
  white-space: normal;
  line-height: 1.4;

  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.4) transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.35);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.55);
  }

  h4,
  p {
    color: inherit;
  }
`;

export const StyledFindOutMoreLink = styled.a`
  display: block;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  font-weight: bold;
  color: inherit;
  text-decoration: underline;

  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

export const StyledDelaySentence = styled.p`
  margin: 0;
  font-weight: bold;

  &:not(:last-child) {
    margin-bottom: 12px;
  }
`;

export const StyledNews = styled.div`
  & + & {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid currentColor;
  }

  p {
    margin: 4px 0 0;
  }
`;

export const StyledNewsTitle = styled.h4`
  margin: 0;
  font-weight: bold;
  font-size: inherit;
`;
